<template>
  <v-container v-if="this.zamawiajacy" class="page">
    <table>
      <thead>
        <tr>
          <td>

            <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
              <div class="left-cointainer">
                <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
              </div>
              <div class="right-cointainer">
                Tutore Sp. z o.o.<br>
                ul. Piotrkowska 157A, 90-440 Łódź<br>
                NIP: 7272846163
              </div>
            </div>

          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>

            <p align="center" style="margin-top:20px;">
              <strong>UMOWA ZLECENIE {{ shortNrUmowy() }}</strong>
            </p>
            <p>
              Zawarta w Łodzi pomiędzy:
            </p>
            <p><strong>Zleceniodawcą:</strong></p>
            <p>
              <strong>Tutore Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod nr KRS: 0000867745, NIP: 7272846163, REGON:  387448002, kapitał zakładowy 5.000,00 zł 
            </p>
            <p>reprezentowaną przez <b>{{ changedPelnomocnik() }}</b> działającą na podstawie pełnomocnictwa z dnia 07.12.2023 r., którego kopia stanowi zał. nr 6 do Umowy, zwanym dalej Zleceniodawcą,</p>
            <p>a</p>
            <p>
              <strong>Zleceniobiorcą:</strong>
            </p>
            <p>Panem/Panią {{ imieNazwisko }}, zamieszkałym/ą w {{ miejscowosc }}, {{ kodPocztowy }} przy ul. {{ adresZamieszkania }}., PESEL {{ pesel }}.</p>
            <br><br>
            <p class="p-margin"><b>Okres trwania umowy i okres wypowiedzenia:</b></p>
            <p class="p-margin">Okres trwania umowy: <b>od {{ dataObowiazywaniaUmowyPolski() }} do {{ umowaDo }} r.</b></p>
            <p class="p-margin">Okres wypowiedzenia: <b>{{ okresWypowiedzenia }}</b></p>
            <p><b>Wynagrodzenie:</b></p>
            <p>Kwota brutto: <b>{{ kwota }} PLN /godzinę</b></p>
            <p align="center" style="margin-top: 10px;"><strong>Warunki umowy</strong></p>

            <p align="center" style="margin-bottom: 0px;">
              <strong>§ 1 Przedmiot umowy</strong>
            </p>
            <p style="margin-bottom: 0px;">Na podstawie niniejszej Umowy, Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności (zwanych w dalszej części Umowy Zleceniami lub Usługami) jak:
            </p>
            <ol type="a">
              <li>reprezentowanie Zleceniodawcy wobec osób prywatnych, firm i instytucji,  i udzielanie informacji w zakresie oferowanych przez Zleceniodawcę usług i produktów zgodnie z ofertą Zleceniodawcy, którą Zleceniobiorca zobowiązuje się znać,</li>
              <li>sporządzanie raportów i podsumowań z pracy własnej,</li>
              <li>prezentowanie oferty usług oferowanych przez Zleceniodawcę przed potencjalnymi klientami w szkołach i innych placówkach bądź firmach oraz  przed klientami indywidualnymi,</li>
              <li>podejmowanie działań związanych ze sprzedażą i promocją usług oferowanych przez Zleceniodawcę, w tym organizowanie akcji promocyjnych, badanie rynku i konkurencji,</li>
              <li>realizacja celów budżetowych i jakościowych w projekcie wyznaczonych przez Zleceniodawcę, f. inne zadania zlecone przez Zleceniodawcę.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 40px;">
              <strong>§ 2 Realizacja przedmiotu zlecenia</strong>
            </p>
            <ol>
              <li>Strony ustalają wspólnie, iż Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością i swoją najlepszą wiedzą, tj. będzie:
                <ol type="a">
                  <li>rzetelnie i dokładnie uzupełniać dane w udostępnionych przez Zleceniodawcę narzędziach i oprogramowaniach,</li>
                  <li>przestrzegać określonych przez Zleceniodawcę wytycznych prowadzenia rozmowy z klientem,</li>
                  <li>rzetelnie i dokładnie ewidencjonować godziny wykonywania zlecenia w udostępnionym zestawieniu, o którym mowa w § 5 ust.2,</li>
                  <li>udzielać informacji osobie wskazanej przez Zleceniodawcę o niezakończonych zadaniach w ramach realizacji przedmiotu zlecenia w danym dniu.</li>
                </ol>
              </li>
              <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy. Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
              <li>Zleceniobiorca będzie wykonywał Zlecenie wg grafików obecności uprzednio ustalonych wspólnie ze Zleceniodawcą.</li>
              <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
              <li>Zleceniobiorca zobowiązuje się do dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
              <strong>§ 3 Obowiązek informacyjny</strong>
            </p>
            <ol>
              <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy oraz poszczególnych zleceń.
              </li>
              <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy oraz poszczególnych zleceń.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 5px;">
              <strong>§ 4 Okres wypowiedzenia</strong>
            </p>
            <ol>
              <li>Strony mogą rozwiązać Umowę z zachowaniem 5-dniowego okresu wypowiedzenia liczonego jako dni robocze, od dnia pisemnego przesłania informacji o wypowiedzeniu umowy (z zastrzeżeniem ustępu 2.).</li>
              <li>Zleceniodawca ma prawo rozwiązać niniejszą Umowę bez zachowania okresu wypowiedzenia w przypadkach wskazanych w umowie, a w szczególności gdy:
                <ol type="a">
                  <li>Zleceniobiorca nie wykonuje obowiązków określonych w § 1 ust. 1 niniejszej Umowy, pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń;</li>
                  <li>Zleceniobiorca dopuścił się naruszenia zakazu konkurencji;</li>
                  <li>Zleceniobiorca ujawnił Informacje Poufne Zleceniodawcy;</li>
                  <li>Zleceniodawca dopuścił się naruszenia innych postanowień niniejszej Umowy.</li>
                </ol>
              </li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
              <strong>§ 5 Termin i sposób zapłaty wynagrodzenia </strong>
            </p>
            <ol>
              <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, do 15-tego dnia następnego miesiąca, w wysokości stanowiącej iloczyn stawki godzinowej oraz liczby godzin przepracowanych w danym miesiącu, w oparciu o zestawienie, o którym mowa w ust. 2 poniżej, przelewem na rachunek bankowy Zleceniobiorcy.</li>
              <li>Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej zestawienia liczby godzin przepracowanych w danym miesiącu najpóźniej w pierwszym dniu roboczym następnego miesiąca. Zweryfikowane przez Zleceniodawcę zestawienie będzie stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
              <strong>§ 6 Klauzula poufności</strong>
            </p>
            <ol>
              <li>Strony, w związku z zawarciem niniejszej umowy zobowiązane są zachować w tajemnicy oraz zapewnić należytą ochronę informacji poufnych przekazanych sobie dla potrzeb realizacji niniejszej umowy. Strony odpowiadają za zachowanie w poufności informacji poufnych podmiotom, przy pomocy których realizują niniejszą umowę, a w szczególności zobowiązane są do odebrania od tych podmiotów stosownych oświadczeń woli.</li>
              <li>Za informacje poufne Strony uznają w szczególności materiały, dokumenty i informacje dotyczące kwestii:
                <p>finansowych</p>
                <p>technicznych,</p>
                <p>handlowych,</p>
                <p>know – how,</p>
                <p>koncepcji,</p>
                <p>strategii,</p>
                <p>źródeł i sposobów finansowania, niezależnie od sposobu i formy ich przekazania.</p>
                <p>Za poufne Strony nie uznają w szczególności materiałów, dokumentów i informacji, które:</p>
                <ol type="a">
                  <li>w dacie ich ujawnienia stanowią informacje dostępne publicznie;</li>
                  <li>są już w dacie podpisania niniejszej umowy znane Stronom i wiedza ta została nabyta zgodnie z prawem, w sposób niezwiązany z realizacją przedmiotu niniejszej umowy;</li>
                  <li>zostały po zawarciu niniejszej umowy pozyskane przez Stronę od podmiotów trzecich, które z kolei nie pozyskały takiej informacji bezpośrednio lub pośrednio od drugiej Strony i nie naruszyły w inny sposób jakiegokolwiek zobowiązania poufności.</li>
                </ol>
              </li>
              <li>Zleceniobiorca zobowiązuje się zachować w tajemnicy wszelkie niewymienione w ust. 2 informacje, których ujawnienie mogłoby narazić Zleceniodawcę na szkodę.</li>
              <li>W przypadku gdy Strona, zgodnie z ogólnie obowiązującymi przepisami prawa, w szczególności na wezwanie organów działających w granicach swoich uprawnień ujawni informacje poufne przekazane jej przez drugą Stronę w ramach realizacji niniejszej umowy, ograniczenia wynikające z niniejszego paragrafu nie znajdą zastosowania i działanie takie nie będzie rodziło po stronie Strony ujawniającej informacje żadnej odpowiedzialności.</li>
              <li>Strony zobowiązują się chronić opisane w niniejszym paragrafie informacje poufne w okresie realizacji niniejszej umowy, a także w okresie 36 (trzydziestu sześciu) miesięcy po jej rozwiązaniu lub wygaśnięciu.</li>
              <li>W przypadku naruszenia zobowiązań wynikających z niniejszego paragrafu Strona naruszająca zapłaci na żądanie drugiej Strony karę umowną w kwocie 20 000,00 (słownie: dwadzieścia tysięcy) złotych.</li>
              <li>Zastrzeżenie wyżej wymienionej kary umownej nie wyklucza dochodzenia odszkodowania przenoszącego w/w kary umownej.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 50px;">
              <strong>§ 7 Doręczenia i korespondencja</strong>
            </p>
            <ol>
              <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron, uważa się za doręczone najpóźniej z datą upływu terminy do odbioru drugiego awizo.</li>
              <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 30px;">
              <strong>§ 8 Spory i sąd właściwy</strong>
            </p>
            <p>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 (czternastu) dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</p>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 10px;">
              <strong>§ 9 Kompletność oraz zmiana umowy </strong>
            </p>
            <ol>
              <li>Umowa niniejsza rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
              <li>Strony oświadczają, że poza niniejszą umowa nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
              <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
              <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 15px;">
              <strong>§ 10 Klauzula salwatoryjna</strong>
            </p>
            <p>Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.</p>
            <br>

            <p align="center" style="margin-bottom: 0px;">
              <strong>§ 11 Prawo właściwe</strong>
            </p>
            <ol>
              <li>Niniejsza umowa podlega prawu polskiemu.</li>
              <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
            </ol>
            <br>

            <p align="center" style="margin-bottom: 0px; margin-top: 20px;">
              <strong>§ 12 Liczba egzemplarzy umowy</strong>
            </p>
            <p>Umowa niniejsza została sporządzona w 2 (dwóch) jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
              <br>
            </p>
            <br>

            <div>
              <p class="underline">Załączniki stanowiące integralną część umowy:</p>
              <ol>
                <li class="underline">Informacja o monitoringu zajęć on - line</li>
                <li class="underline">Klauzula informacyjna RODO</li>
                <li class="underline">Oświadczenie do umowy zlecenia</li>
                <li class="underline">Upoważnienie do przetwarzania danych osobowych </li>
                <li class="underline">Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
                
              </ol>
            </div>

            <div class="cointainer" style="margin-top: 30px;">
              <div class="left-cointainer">
                <span style="margin-left: 0%;"><b>Podpis Zleceniodawcy</b></span>
                <br>
                <span style="margin-left: 0%;"><b>{{ zamawiajacy }}</b></span>
              </div>
              <div class="right-cointainer">
                <span style="margin-left: 0%;"><b>Podpis Zleceniobiorcy</b></span>
                <br>
                <span><b>{{ imieNazwisko }}</b></span>
              </div>
            </div>
            <br>

            <div style="page-break-before: always;">
              <p><b>Załącznik nr 1 Informacja o monitoringu zajęć on-line</b></p>
              <p class="subheading" style="margin-bottom: 0px;"><strong>Informacja o monitoringu zajęć online i
                  nagrywaniu szkoleń wewnętrznych online</strong></p>
              <br>
              Informujemy, iż Tutore Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring
              prowadzonych zajęć on-line oraz nagrywania szkoleń wewnętrznych on-line. Monitoringiem są objęte
              urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online
              tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom.
              Tutore Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów
              obsługi zajęć lekcyjnych realizowanych przez pracowników/zleceniobiorców, prawidłowości wykonywania
              powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w
              sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on-line w celu
              zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. Informujemy, iż: system
              monitoringu audiowizualnego i dźwiękowego zajęć on-line składa się z systemu rejestrującego platformy
              Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć
              online posiadają osoby upoważnione przez Zarząd Tutore Sp. z o.o. tj. Manager Działu Call Center,
              Dyrektor ds. Zarządzania Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do
              zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają
              stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do
              przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska
              pracownika/zleceniobiorcy prowadzącego zajęcia lub szkolenie. Administratorem danych osobowych uzyskanych
              w ramach monitoringu zajęć on-line i w toku nagrywania szkoleń wewnętrznych on-line jest Tutore Sp.
              z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną
              dotyczącą przetwarzania danych osobowych.
            </div>

            <div style="page-break-before: always; margin-top: 30px;">
              <p><strong>Załącznik nr 2 Klauzula informacyjna RODO</strong></p>
              <ol>
              <li>Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, Tutore Sp. z o.o. informuje:</li>
              <li>Administratorem Danych Osobowych jest Tutore Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel. 535 933 870 info@tutore.eu, dalej ADO.</li>
              <li>Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.</li>
              <li>ADO przetwarza dane osobowe w następujących celach, na następującej podstawie i w następującym okresie:
                <ol>
                  <li>zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,</li>
                  <li>wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,</li>
                  <li>potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,</li>
                  <li>realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
                  <li>realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika składek na ubezpieczenie społeczne i zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
                  <li>realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,</li>
                  <li>bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,</li>
                  <li>zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
                  <li>zapewnienia możliwości udostępnienia nagrań nowym Zleceniobiorcom, Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
                  <li>zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
                  <li>dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.</li>
                </ol>
              </li>
              <li>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</li>
              <li>Dane osobowe przechowywane będą przez odpowiedni okres wskazany w ust. 4. Po upływie tego okresu dane osobowe przechowywane w systemach informatycznych podlegają usunięciu, a nośniki informacji przechowujące dane, podlegają zniszczeniu.</li>
              <li>Odbiorcami Pani/Pana danych osobowych będą:
                <ol>
                  <li>organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa,</li>
                  <li>zakłady opieki zdrowotnej w celach związanych z medycyną pracy,</li>
                  <li>podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,</li>
                  <li>biura księgowe,</li>
                  <li>banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy,</li>
                  <li>kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z zajmowanym przez Zleceniobiorcę stanowiskiem pracy,</li>
                  <li>współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,</li>
                  <li>podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług,</li>
                  <li>instytucje ubezpieczeniowe,</li>
                  <li>organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą),</li>
                  <li>podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy).</li>
                </ol>
              </li>
              <li>Osoba której dane są przetwarzane ma prawo:
                <ol type="a">
                  <li><b>dostępu do danych</b> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);</li>
                  <li><b>otrzymania kopii danych</b> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);</li>
                  <li><b>sprostowania</b> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);</li>
                  <li><b>usunięcia danych</b> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);</li>
                  <li><b>ograniczenia przetwarzania</b> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
                    <ul>
                      <li>kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,</li>
                      <li>przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,</li>
                      <li>Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;</li>
                      <li>wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;</li>
                    </ul>
                  </li>
                  <li><b>przenoszenia danych</b> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu. Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);</li>
                  <li><b>sprzeciwu</b> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);</li>
                  <li><b>prawo wniesienia skargi do organu nadzorczego</b> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
                    <ul>
                      <li>pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,</li>
                      <li>elektronicznie za pośrednictwem platformy ePUAP.</li>
                    </ul>
                  </li>
                </ol>
              </li>
              <li>W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.</li>
              <li>Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.</li>
              </ol>
            </div>

            <div style="page-break-before: always;">
              <table style="margin-top: 30px;">
              <tbody style="border: 1px solid; text-align: left; font-size: 13px; width: 100%;">

                    <tr>
                      <td style="padding: 10px;">
                        <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
                        <ol style="line-height: 1.7;">
                      <li>Ja niżej podpisany/a oświadczam, iż:
                      <ol type="a">
                        <li>zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,</li>
                        <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
                        </ol>
                        </li>
                        <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
                        <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody.</li>
                        <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.</li>
                        </ol>
                        <div class="right-cointainer" style="float: right; margin-top: 20px;">
                      <span style="font-size: 14px;">{{imieNazwisko}}</span>
                      <br>
                      <span>czytelny podpis Zleceniobiorcy</span>
                      </div>
                    </td>
                  </tr>

              </tbody></table>
            </div>

            <div style="margin-top:5px;page-break-before: always;">
      <p>Załącznik nr 3: <span class="underline">Oświadczenie do umowy zlecenia</span></p>

      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tbody>

          <tr>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
              <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
            </td>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Data</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ data }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ imieNazwisko }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Numer PESEL</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ pesel }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr
                  PESEL)</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nrDowodu }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ obywatelstwo }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Numer telefonu</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nrTelefonu }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Adres e-mail</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ email }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table">
                <span>Adres zamieszkania</span>
                <br>
                <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
              </p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table bigCell"><span>{{ adresZamieszkania }}, {{ kodPocztowy }}, {{ miejscowosc }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table">
                <span>Adres korespondencyjny</span>
                <br>
                <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
              </p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ adresKorespondencyjny }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table">
                <span>Urząd Skarbowy</span>
                <br>
                <span>(zgodny z adresem zamieszkania)</span>
              </p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table bigCell"><span>{{ urzadSkarbowy }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nrRachunku }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
            </td>
            <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest
                    wymagany)</strong></span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ emeryt }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ rencista }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ orzeczenieNiepelnosprawnosc }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień
                  niepełnosprawności</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br> (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ student }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku
                  objęcia ubezpieczeniem emerytalnym i rentowym)</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ chorobowe.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli
                  wpisano "TAK", proszę uzupełnić poniższe dane) / I am employed under an employment contract</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Sp. z o.o.<br> (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ nazwaUmowaPraca }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore<br> jest wyższe bądź równe krajowej płacy minimalnej.</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '') }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe<br> (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ wniosekUbezpieczenie }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu niż umowa zlecenie z Tutore Sp. z o.o.<br> (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza):</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ ubezpieczenieUmowaPraca }}</span></p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł
                  ubezpieczenia</span></p>
            </td>
            <td style="border: 1px solid;">
              <p class="cell-in-first-table"><span>{{ tytulUbezpieczenieUmowaPraca }}</span></p>
            </td>
          </tr>

          <tr>
            <td colspan="2" class="fs-14" style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
              <p class="cell-in-first-table"><span><strong>
                Wypełnienie powyższego oświadczenia oznacza zgodę na podanie Tutore Sp. z o.o. numeru telefonu, e-mail i adresu do korespondencji, jak również oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym, oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
                <br />
                W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
                <br />
              </strong></span></p>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

            <div style="margin-top:5px;page-break-before: always;">
              <p align="center" class="subheading" style="margin-bottom: 10px;">
                <strong>
                  Załącznik nr 4 Upoważnienie do przetwarzania danych osobowych w zbiorze w wersji elektronicznej
                </strong>
              </p>
              <p class="p-margin">
                Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016
                r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego
                przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej
                RODO, niniejszym:
              </p>
              <p class="p-margin">
                z dniem {{ aktualnaData() }} r.
              </p>
              <p class="p-margin">
                upoważniam Pana/Panią {{ imieNazwisko }} Zleceniobiorcę Tutore Sp. z o.o. realizującego umowę zlecenie do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych: w wersji elektronicznej:
              </p>
              <p>
                zbiór danych osobowych kandydatów do zatrudnienia przez Tutore Sp. z o.o. – imię i nazwisko, telefon kontaktowy zbiór danych osobowych osób prowadzących zajęcia w usługach oferowanych przez Tutore Sp. z o.o. – imię i nazwisko, telefon kontaktowy, dane adresowe, pozostałe dane niezbędne do przygotowania umowy.</p>
              <p>
                zbiór danych osobowych osób realizujących umowy cywilnoprawne w Tutore Sp. z o.o. – imię i nazwisko, telefon kontaktowy, dane adresowe, pozostałe dane niezbędne do przygotowania umowy.
              </p>
              <p>
                w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
              </p>
              <p class="p-margin">
                Niniejsze upoważnienie nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
              </p>
              <p>
                Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Sp. z o.o. wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
              </p>
              <p>
                Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
              </p>

              <div class="container" style="page-break-before: always;">
                <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
                  <tr>
                    <td id="oswiadczenie">
                      <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
                      <ol>
                        <li>Ja niżej podpisany/a oświadczam, iż:
                          <ol type="a">
                            <li>
                              zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
                            </li>
                            <li>
                              treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi
                              wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
                            </li>
                            <li>
                              zobowiązuję się do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych
                              w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
                            </li>
                            <li>
                              zobowiązuję się do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem,
                              przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką
                              Prywatności,
                            </li>
                            <li>
                              zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał
                              dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Sp. z o.o. oraz zachowania
                              w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie
                              upoważnienia, a także po zakończeniu trwania umowy zlecenie.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <div class="right-cointainer" style="float: right; margin-top: 20px;">
                        <span style="font-size: 14px;">{{ imieNazwisko }}</span>
                        <br>
                        <span>czytelny podpis Zleceniobiorcy</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>

              <p style="text-align: center;">data i podpis</p>
              <p style="text-align: center;">{{ aktualnaData() }} r.</p>
              <p class="subheading p-margin" style="text-align: center;">
                <strong>{{ zamawiajacy }}</strong>
                <br>
                <strong>w imieniu Administratora</strong>
              </p>
              <br>
              <p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie.</p>
            </div>


          <div style="margin-top: 5px;page-break-before: always;">
            <p><em><b>Załącznik nr 5 Ogólne zasady bhp przy pracy administracyjno-biurowej</b></em></p>
            <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY
                ADMINISTRACYJNO-BIUROWEJ</strong></p>
            <br>
            <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
            <ul>
              <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).
              </li>
              <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
              <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie
                powinna być mniejsza niż 40%.</li>
              <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
              <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i
                innych urządzeń.</li>
            </ul>
            <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
            <ul>
              <li>Zaplanować kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
              <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
              <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
              <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i
                elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
              <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
            </ul>
            <p>Czynności, które należy wykonywać podczas pracy:</p>
            <ul>
              <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
              <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
            </ul>
            <p>Czynności zabronione:</p>
            <ul>
              <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
              <li>Otwierania osłon podczas pracy urządzeń.</li>
              <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja
                na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
            </ul>
            <p>Uwagi końcowe:</p>
            <ul>
              <li>
                Przy stałej pracy przy komputerze należy:
                <ul>
                  <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi
                    narządu wzroku i wykonywanymi w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy
                    przy obsłudze monitora ekranowego lub</li>
                  <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora
                    ekranowego.</li>
                </ul>
              </li>
            </ul>
            <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy
              administracyjno-biurowej.</p>
            <div style="margin-top: 40px; font-size: 10px;">
              <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
              <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
            </div>
          </div>

      </td>
    </tr>
  </tbody>
  </table>
  </v-container>
</template>

<script>
import { odmienionyPelnomocnik } from '../helpers';

export default {
  name: 'UmowaAnimatorTutore',
  data() {
    return {
      miejscowosc: '',
      kodPocztowy: '',
      adresKorespondencyjny: '',
      pesel: '',
      nrDowodu: '',
      obywatelstwo: '',
      obywatelstwoA: '',
      obywatelstwoB: '',
      nrTelefonu: '',
      email: '',
      urzadSkarbowy: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      wniosekUbezpieczenie: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      stanowisko: '',
      oddzial: '',
      zamawiajacy: '',
      sprzetSluzbowy: '',
      samochodSluzbowy: '',
      okresWypowiedzenia: '',
      kwota: '',
      slownieKwota: '',
      maksimumGodzin: '',
      nrUmowy: '',
      nrRachunku: '',
      adresZamieszkania: '',
      imieNazwisko: '',
      data: '',
      umowaOd: '',
      umowaDo: '',
    }
  },
  created() {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    changedPelnomocnik() {
      return odmienionyPelnomocnik(this.zamawiajacy);
    },
    dataObowiazywaniaUmowyPolski() {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'dnia podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    shortNrUmowy() {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch (tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Nau/Lek/Anim'
          break
        default:
          shortPosition = tab[3]
      }
      let shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      if (tab.length > 6) {
        shortUmowa += `/${tab[6]}`
      }
      return shortUmowa
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if ((day + 1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth() + 1;
      if ((today.getMonth() + 1) < 10) {
        month = '0' + month
      }
      const todayDate = day + '-' + month + '-' + today.getFullYear()
      return todayDate
    }
  },
  mounted() {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th,
td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}

.fs-14 {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaAnimatorTutore.vue